import { render, staticRenderFns } from "./MessageEdit.vue?vue&type=template&id=70b6dde2&scoped=true&"
import script from "./MessageEdit.vue?vue&type=script&lang=js&"
export * from "./MessageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6dde2",
  null
  
)

export default component.exports